export const ENDPOINT = 'api/update-user-info';

export type GetUserInfoMutationRequest = {
  token: string;
};

export type GetUserInfoMutationResponse = {
  success: boolean;
  data: {
    id: string;
    auth_token: string;
    name: string;
    email: string;
    phone: string;
    default_address_id: string;
    default_address: {
      latitude: string;
      longitude: string;
    } | null;
    wallet_balance: string;
    avatar: string | null;
    tax_number: string | null;
  };
  running_order: null;
  delivery_details: null;
};
